import { computed } from 'vue';
import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router';

import routes from './routes';

import { useCachedViewStoreHook } from '@/store/modules/cached-view';
import NProgress from '@/utils/progress';
import setPageTitle from '@/utils/set-page-title';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export interface toRouteType extends RouteLocationNormalized {
  meta: {
    title?: string;
    noCache?: boolean;
  };
}

router.beforeEach((to: toRouteType, from, next) => {
  NProgress.start();
  // 路由缓存
  useCachedViewStoreHook().addCachedView(to);
  // 页面 title
  setPageTitle(to.meta.title);
  next();
});

router.afterEach(() => {
  NProgress.done();
});

// 导出缓存视图列表的 computed，供 App.vue 使用
export function useCachedViews() {
  const cachedViewStore = useCachedViewStoreHook();
  return computed(() => cachedViewStore.cachedViewList);
}

export default router;
